import * as React from "react";
const SvgFiRrN = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-n_svg__a)">
      <path
        fill="#062147"
        d="M18.37 24.006c-1.411 0-2.662-.813-3.246-2.178L7.038 2.96c-.375-.876-1.163-1.051-1.773-.927C4.654 2.158 4 2.632 4 3.583V23c-.005 1.308-1.995 1.307-2 0V3.583C2 1.835 3.15.425 4.862.073 6.57-.278 8.187.566 8.876 2.173l8.086 18.869c.375.874 1.159 1.049 1.773.927.611-.126 1.265-.6 1.265-1.551V1c.006-1.308 1.995-1.307 2 0v19.417c0 1.748-1.15 3.158-2.862 3.51a4 4 0 0 1-.768.079"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-n_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrN;
